import * as React from "react";
import { useColorScheme } from "@mui/joy/styles";
import Box from "@mui/joy/Box";
import IconButton, { IconButtonProps } from "@mui/joy/IconButton";
import Typography from "@mui/joy/Typography";
import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import BadgeRoundedIcon from "@mui/icons-material/BadgeRounded";

function ColorSchemeToggle(props: IconButtonProps) {
   const { onClick, ...other } = props;
   const { mode, setMode } = useColorScheme();
   const [mounted, setMounted] = React.useState(false);
 
   React.useEffect(() => setMounted(true), []);
 
   return (
     <IconButton
       aria-label="toggle light/dark mode"
       size="sm"
       variant="outlined"
       disabled={!mounted}
       onClick={(event) => {
         setMode(mode === "light" ? "dark" : "light");
         onClick?.(event);
       }}
       {...other}
     >
       {mode === "light" ? <DarkModeRoundedIcon /> : <LightModeRoundedIcon />}
     </IconButton>
   );
 }

export default function Header() {
  return (
    <Box
      component="header"
      sx={{ py: 3, display: "flex", justifyContent: "space-between" }}
    >
      <Box sx={{ gap: 2, display: "flex", alignItems: "center" }}>
        <img alt="ISKCON Kanpur logo" src="https://cdn.iskconkanpur.org/static/brand/isk-logo-circle.png" style={{ width: 50, height: 50 }} />
        <Typography level="title-lg">ISKCON Kanpur</Typography>
      </Box>
      <ColorSchemeToggle />
    </Box>
  );
}
